module.exports = __webpack_public_path__ + "static/media/تابلو-برق2.9e5ed513.jpg";